/**
 * Auth Feature Routes
 * Mirrors: interactions-uhci-webui2/src/app/auth/auth-routing.module.ts
 * 
 * Routes:
 * - /login
 */

import { RouteConfig } from '../../types';

/**
 * Auth routes — login flow
 * Layout: public (no header/nav)
 * Guards: none (unauthenticated users need to access)
 */
export const authRoutes: RouteConfig[] = [
  {
    path: 'login',
    // TODO: Import actual login component from @src/auth or similar
    // component: LoginComponent,
    layout: 'public',
    guards: [],  // No guards for login
    data: {
      title: 'Login',
      breadcrumb: 'Sign In'
    }
  }
];

export default authRoutes;
